module.exports = __webpack_public_path__ + "static/img/407.90571c20.jpg";